import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AdminRoleBasedGuardService } from './services/guards/admin-role-based-guard.service';
import { SuperAdminLoginComponent } from './super-admin-login/super-admin-login.component';


const routes: Routes = [
  { path: '', component: LoginComponent },  // default route
  { path: 'super-admin', component: SuperAdminLoginComponent },  // default route
  // add other routes here
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [AdminRoleBasedGuardService]
  },
  {
    path: 'super-admin',
    loadChildren: () => import('./super-admin/super-admin.module').then(m => m.SuperAdminModule),
    canActivate: [AdminRoleBasedGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
